var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { property } from 'lit-element';
import notify from './lib/notify';
function checkId(value, old) {
    return !old || old.id !== value.id;
}
/**
 * A base shell mixin class which uses `Alcaeus` Hydra client to load the resources
 *
 * @mixinFunction
 */
export default function (Base) {
    class Mixin extends Base {
        async loadResourceInternal(url) {
            return import('alcaeus').then(({ Hydra }) => Hydra.loadResource(url));
        }
        updated(props) {
            super.updated(props);
            notify(this, props, 'entrypoint');
        }
        onResourceLoaded(response) {
            if (!(response && response.root)) {
                return;
            }
            const resource = response.root;
            resource.apiDocumentation && resource.apiDocumentation.do({
                just: (apiDocumentation) => {
                    apiDocumentation.loadEntrypoint()
                        .then((entrypoint) => {
                        this.entrypoint = entrypoint.root;
                    })
                        .catch((e) => {
                        this._log.warn(`Failed to load entrypoint`);
                        this._log.error(e);
                    });
                },
            });
        }
    }
    __decorate([
        property({ type: Object, hasChanged: checkId })
    ], Mixin.prototype, "entrypoint", void 0);
    return Mixin;
}
